import index from '@/assets/utils/index'

export default [
  {
    url: index.linkApp,
    name: 'Download ZX App',
    slug: 'external',
    icon: 'ArrowRightCircleIcon',
    i18n: 'Download ZX App'
  },
  {
    url: '/notification',
    name: 'Notifikasi',
    slug: 'internal',
    icon: 'ArrowRightCircleIcon',
    i18n: 'Notifikasi'
  },
  {
    url: '/sahabat-zx',
    name: 'Sahabat ZX',
    slug: 'internal',
    icon: 'ArrowRightCircleIcon',
    i18n: 'Sahabat ZX'
  },
  {
    url: '/message',
    name: 'Message',
    slug: 'internal',
    icon: 'ArrowRightCircleIcon',
    i18n: 'Message'
  }
]

